<template>
  <v-card flat class="pa-4">
    <!-- Snackbar -->
    <v-snackbar v-model="mensaje.snackbar" :timeout="mensaje.timeout" :color="mensaje.color" text top right>
      {{ mensaje.text }}
      <template v-slot:action="{ attrs }">
        <v-btn :color="mensaje.colorBtn" text v-bind="attrs" @click="mensaje.snackbar = false">Cerrar</v-btn>
      </template>
    </v-snackbar>

    <!-- Botón nueva categoría -->
    <v-row class="mb-3">
      <v-col>
        <v-btn color="teal" dark @click="openDialog(null)">
          <v-icon left>mdi-plus</v-icon> Nueva Categoría
        </v-btn>
      </v-col>
    </v-row>

    <!-- Tabla de categorías -->
    <v-simple-table fixed-header>
      <template v-slot:default>
        <thead>
          <tr>
            <th>Id</th>
            <th>Nombre</th>
            <th>Descripción</th>
            <th>Color</th>
            <th>Icono</th>
            <th>Orden</th>
            <th>Activa</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="cat in categorias" :key="cat.id">
            <td>{{ cat.id }}</td>
            <td>{{ cat.name }}</td>
            <td>{{ cat.description }}</td>
            <td>
              <v-avatar size="20" :color="cat.color || '#E0E0E0'"></v-avatar>
            </td>
            <td><v-icon v-if="cat.icon">{{ cat.icon }}</v-icon></td>
            <td>{{ cat.order }}</td>
            <td>
              <v-chip :color="cat.active ? 'green' : 'grey'" dark small>
                {{ cat.active ? 'Sí' : 'No' }}
              </v-chip>
            </td>
            <td>
              <v-btn icon color="primary" @click="openDialog(cat)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon color="red" @click="eliminar(cat)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <!-- Dialog crear/editar categoría -->
    <v-dialog v-model="dialog" max-width="550" persistent scrollable>
      <v-card>
        <v-card-title>{{ editando ? 'Editar' : 'Nueva' }} Categoría</v-card-title>
        <v-card-text>
          <v-form ref="formCat" v-model="validCat">
            <v-text-field v-model="catForm.name" label="Nombre" :rules="[v => !!v || 'Requerido']" required outlined dense></v-text-field>
            <v-text-field v-model="catForm.description" label="Descripción (opcional)" outlined dense></v-text-field>
            <v-text-field v-model="catForm.icon" label="Icono (ej: mdi-laptop)" hint="Clases de Material Design Icons" outlined dense>
              <template v-slot:prepend-inner>
                <v-icon small>{{ catForm.icon || 'mdi-help' }}</v-icon>
              </template>
            </v-text-field>
            <v-text-field v-model.number="catForm.order" label="Orden" type="number" outlined dense></v-text-field>

            <v-divider class="my-3"></v-divider>
            <p class="subtitle-2 grey--text">Banner de la categoría</p>

            <v-radio-group v-model="bannerMode" row dense hide-details class="mb-2">
              <v-radio label="Subir imagen" value="upload"></v-radio>
              <v-radio label="Elegir de galería" value="gallery"></v-radio>
              <v-radio label="URL personalizada" value="custom"></v-radio>
            </v-radio-group>

            <!-- Subir imagen -->
            <div v-if="bannerMode === 'upload'" class="mb-2">
              <v-file-input v-model="bannerFile" label="Seleccionar imagen" accept="image/*"
                prepend-icon="mdi-image" show-size dense
                hint="Se sube al guardar la categoría (máx 5MB)" persistent-hint></v-file-input>
            </div>

            <!-- Galería de banners públicos -->
            <div v-if="bannerMode === 'gallery'" class="mb-2">
              <v-row dense>
                <v-col cols="4" v-for="(item, i) in bannerGallery" :key="i">
                  <v-card outlined :class="{ 'gallery-selected': catForm.banner_url === item.url }"
                    @click="selectGalleryBanner(item.url)" style="cursor: pointer;">
                    <v-img :src="item.url" height="60" contain></v-img>
                    <p class="caption text-center mb-0 pa-1">{{ item.label }}</p>
                  </v-card>
                </v-col>
              </v-row>
            </div>

            <!-- URL personalizada -->
            <div v-if="bannerMode === 'custom'" class="mb-2">
              <v-text-field v-model="catForm.banner_url" label="URL del banner" outlined dense
                hint="URL pública de una imagen" persistent-hint></v-text-field>
            </div>

            <!-- Preview del banner -->
            <div v-if="bannerPreviewUrl" class="mb-3">
              <p class="caption grey--text">Preview:</p>
              <v-img :src="bannerPreviewUrl" max-height="100" contain
                class="rounded grey lighten-3"></v-img>
            </div>

            <v-divider class="my-3"></v-divider>
            <p class="subtitle-2 grey--text">Otros campos</p>

            <v-row align="center">
              <v-col cols="8">
                <v-text-field v-model="catForm.color" label="Color temático" outlined dense
                  hint="Código hexadecimal" persistent-hint></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-menu :close-on-content-click="false" offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn outlined small v-bind="attrs" v-on="on">
                      <v-avatar size="20" :color="catForm.color || '#E0E0E0'" class="mr-1"></v-avatar>
                      Elegir
                    </v-btn>
                  </template>
                  <v-color-picker v-model="catForm.color" hide-inputs show-swatches
                    :swatches="colorSwatches" mode="hexa"></v-color-picker>
                </v-menu>
              </v-col>
            </v-row>

            <v-text-field v-model="catForm.detail_1" label="Detalle 1 (opcional)" outlined dense></v-text-field>
            <v-text-field v-model="catForm.detail_2" label="Detalle 2 (opcional)" outlined dense></v-text-field>

            <v-switch v-model="catForm.active" label="Activa" color="teal"></v-switch>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">Cancelar</v-btn>
          <v-btn color="teal" dark @click="guardarCategoria">{{ editando ? 'Actualizar' : 'Guardar' }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import forumService from '@/services/forumService.js';

export default {
  name: 'ForumCategoriaAdmin',
  data() {
    return {
      categorias: [],
      dialog: false,
      editando: false,
      validCat: true,
      catForm: {
        id: null,
        name: '',
        description: '',
        icon: '',
        order: 0,
        active: true,
        banner_url: '',
        color: '',
        detail_1: '',
        detail_2: ''
      },
      bannerMode: 'gallery',
      bannerFile: null,
      bannerGallery: [
        { label: 'Tecnología', url: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=800&h=200&fit=crop' },
        { label: 'Educación', url: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=800&h=200&fit=crop' },
        { label: 'Naturaleza', url: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=800&h=200&fit=crop' },
        { label: 'Abstracto', url: 'https://images.unsplash.com/photo-1557683316-973673baf926?w=800&h=200&fit=crop' },
        { label: 'Ciudad', url: 'https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?w=800&h=200&fit=crop' },
        { label: 'Espacio', url: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&h=200&fit=crop' },
        { label: 'Salud', url: 'https://images.unsplash.com/photo-1505751172876-fa1923c5c528?w=800&h=200&fit=crop' },
        { label: 'Negocios', url: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&h=200&fit=crop' },
        { label: 'Minimalista', url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&h=200&fit=crop' }
      ],
      colorSwatches: [
        ['#E3F2FD', '#BBDEFB', '#90CAF9'],
        ['#E8F5E9', '#C8E6C9', '#A5D6A7'],
        ['#FFF3E0', '#FFE0B2', '#FFCC80'],
        ['#F3E5F5', '#E1BEE7', '#CE93D8'],
        ['#ECEFF1', '#CFD8DC', '#B0BEC5'],
        ['#FFEBEE', '#FFCDD2', '#EF9A9A']
      ],
      mensaje: {
        snackbar: false,
        text: '',
        color: '',
        colorBtn: '',
        timeout: 4000
      }
    };
  },
  mounted() {
    this.listarCategorias();
  },
  computed: {
    bannerPreviewUrl() {
      if (this.bannerMode === 'upload' && this.bannerFile) {
        return URL.createObjectURL(this.bannerFile);
      }
      if (this.catForm.banner_url) {
        if (this.catForm.banner_url.startsWith('http')) return this.catForm.banner_url;
        if (this.catForm.id) return forumService.getCategoryBannerUrl(this.catForm.id, this.catForm.banner_url);
      }
      return '';
    }
  },
  methods: {
    listarCategorias() {
      forumService.listarCategorias().then(res => {
        this.categorias = res.data;
      });
    },
    openDialog(cat) {
      this.bannerFile = null;
      if (cat) {
        this.editando = true;
        this.catForm = {
          id: cat.id,
          name: cat.name,
          description: cat.description || '',
          icon: cat.icon || '',
          order: cat.order || 0,
          active: cat.active,
          banner_url: cat.banner_url || '',
          color: cat.color || '',
          detail_1: cat.detail_1 || '',
          detail_2: cat.detail_2 || ''
        };
        // Determinar modo del banner
        if (cat.banner_url && cat.banner_url.startsWith('http')) {
          this.bannerMode = 'gallery';
        } else if (cat.banner_url) {
          this.bannerMode = 'upload';
        } else {
          this.bannerMode = 'gallery';
        }
      } else {
        this.editando = false;
        this.catForm = {
          id: null, name: '', description: '', icon: '', order: 0, active: true,
          banner_url: '', color: '', detail_1: '', detail_2: ''
        };
        this.bannerMode = 'gallery';
      }
      this.dialog = true;
    },
    selectGalleryBanner(url) {
      this.catForm.banner_url = url;
    },
    guardarCategoria() {
      if (!this.$refs.formCat.validate()) return;

      const action = this.editando
        ? forumService.updateCategoria(this.catForm.id, this.catForm)
        : forumService.saveCategoria(this.catForm);

      action.then(res => {
        const categoryId = res.data.category ? res.data.category.id : this.catForm.id;

        // Si hay archivo de banner para subir
        if (this.bannerMode === 'upload' && this.bannerFile && categoryId) {
          const fd = new FormData();
          fd.append('banner', this.bannerFile);
          forumService.uploadCategoryBanner(categoryId, fd).then(() => {
            this.showMsg(this.editando ? 'Categoría actualizada con banner' : 'Categoría creada con banner', 'success');
            this.dialog = false;
            this.listarCategorias();
          }).catch(() => {
            this.showMsg('Categoría guardada, pero error al subir banner', 'error');
            this.dialog = false;
            this.listarCategorias();
          });
        } else {
          this.showMsg(this.editando ? 'Categoría actualizada' : 'Categoría creada', 'success');
          this.dialog = false;
          this.listarCategorias();
        }
      }).catch(err => {
        const errors = err.response && err.response.data && err.response.data.errors;
        this.showMsg(errors ? errors.join(', ') : 'Error al guardar', 'error');
      });
    },
    eliminar(cat) {
      if (!confirm('¿Eliminar la categoría "' + cat.name + '"?')) return;
      forumService.deleteCategoria(cat.id).then(() => {
        this.showMsg('Categoría eliminada', 'success');
        this.listarCategorias();
      }).catch(() => {
        this.showMsg('Error al eliminar', 'error');
      });
    },
    showMsg(text, type) {
      this.mensaje.text = text;
      this.mensaje.color = type === 'success' ? 'success' : 'error';
      this.mensaje.colorBtn = type === 'success' ? 'green darken-1' : 'red darken-1';
      this.mensaje.snackbar = true;
    }
  }
};
</script>

<style scoped>
.gallery-selected {
  border: 2px solid #009688 !important;
  box-shadow: 0 2px 8px rgba(0, 150, 136, 0.3);
}
</style>
